<template>
    <div>
        <v-server-table
                :url="route('faq.table')"
                :columns="columns"
                :options="options"
                class="trigger"
                ref="table"
        >
            <template slot="question" slot-scope="{ row }">
                <router-link :to="{ name: 'admin.faq.view', params: {'id': row.id} }">
                    {{ getShortText(row.question) }}
                </router-link>
            </template>
            <template slot="answer" slot-scope="{ row }">
                {{ getShortText(row.answer) }}
            </template>
        </v-server-table>
    </div>
</template>

<script>
    import { TableMixin } from '~/mixins'
    import { Actions } from '~/components/tables/admin/faq'
    
    export default {
        name: 'FaqTable',
        mixins: [ TableMixin ],
        props: {
            apiUrl: {
                type: String,
                default: route('faq.table'),
            },
            columns: {
                type: Array,
                default: () => [
                    'question',
                    'answer',
                    'actions',
                ],
            },
            filterable: {
                type: Array,
                default: () => [
                    'question',
                    'answer',
                ],
            },
            rowsPerPage: {
                type: String,
                default: "15"
            }
        },
        data () {
            return {
                loading: false,
                templates: {
                    actions: Actions,
                },
                options: {
                    headings: {
                        question: this.uLang('app.question'),
                        answer: this.uLang('app.answer'),
                        actions: this.uLang('app.actions'),
                    },
                },
            }
        },
        methods: {
            getShortText(text) {
                // Strip tags, since we don't want any paragraph tags or the like
                let string = text.replace(/(<([^>]+)>)/ig,"");

                // limit chars
                if (string.length > 100) {
                    string = string.substr(0, 100) + '...';
                }

                return string;
            }
        },
        watch: {
            rowsPerPage(newValue) {
                this.$refs.table.setLimit(Number.parseInt(newValue, 10));
                this.$refs.table.refresh();
            }
        }
    }
</script>

<style>
</style>